// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert--alert--1wxBh","placeholderAnim":"Alert--placeholderAnim--1-9Ji"};